import { pageNames } from '@atc/bonnet-paths';
import { stringDuckCreator } from '@atc/modular-redux';

export default stringDuckCreator({
    store: 'supportMakes',
    initialState: [],
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
